import axios from 'axios';
import type { ProjectData } from '@/lib/project';

const BASE_URL = `${process.env.VUE_APP_API_ROOT}/organizations`;

interface AllResponse {
  data: ProjectData[],
  success: boolean,
}

interface GetResponse {
  data: ProjectData,
  success: boolean,
}

interface PostResponse {
  data: { slug: string },
  success: boolean,
}

interface PutResponse {
  data: {
    name: string,
    slug: string
  },
  success: boolean,
}

interface DeleteResponse {
  success: boolean,
}

export const projectService = {
  async getAll(orgSlug: string): Promise<ProjectData[]> {
    const res = await axios.get<AllResponse>(`${BASE_URL}/${orgSlug}/projects`);
    return res.data.data;
  },

  async getOne(orgSlug: string, slug: string): Promise<ProjectData> {
    const res = await axios.get<GetResponse>(
      `${BASE_URL}/${orgSlug}/projects/${slug}`
    );
    return res.data.data;
  },

  async add(orgSlug: string, data: ProjectData): Promise<string | undefined> {
    const res = await axios.post<ProjectData, { data: PostResponse }>(`${BASE_URL}/${orgSlug}/projects`, data);
    return res.data.success ? res.data.data.slug : undefined;
  },

  async update(
    orgSlug: string,
    slug: string,
    data: ProjectData
  ): Promise<string | undefined> {
    const res = await axios.put<ProjectData, { data: PutResponse }>(`${BASE_URL}/${orgSlug}/projects/${slug}`, data);
    return res.data.success ? res.data.data.slug : undefined;
  },

  async delete(orgSlug: string, slug: string): Promise<boolean> {
    const res = await axios.delete<DeleteResponse>(`${BASE_URL}/${orgSlug}/projects/${slug}`);
    return res.data.success;
  },
};
